var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileMenuCabinet = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 0.916667V2.83336C8.83333 3.76678 8.83333 4.23349 9.01499 4.59001C9.17478 4.90361 9.42974 5.15858 9.74335 5.31837C10.0999 5.50002 10.5666 5.50002 11.5 5.50002H13.4167M13.8333 7.42809V10.5C13.8333 12.8336 13.8333 14.0003 13.3792 14.8916C12.9797 15.6756 12.3423 16.3131 11.5583 16.7125C10.667 17.1667 9.50022 17.1667 7.16667 17.1667C4.83311 17.1667 3.66634 17.1667 2.77504 16.7125C1.99103 16.3131 1.35361 15.6756 0.954139 14.8916C0.5 14.0003 0.5 12.8335 0.5 10.5V6.98181C0.5 4.82247 0.5 3.7428 0.890494 2.90552C1.30447 2.0179 2.0179 1.30447 2.90552 0.890494C3.7428 0.5 4.82247 0.5 6.98181 0.5C7.92538 0.5 8.39717 0.5 8.84274 0.598795C9.31717 0.703991 9.76955 0.891372 10.1794 1.15247C10.5643 1.39767 10.8979 1.73127 11.5651 2.39848L11.8807 2.71404C12.6013 3.43468 12.9617 3.79499 13.2193 4.21548C13.4478 4.58828 13.6161 4.99472 13.7182 5.41987C13.8333 5.8994 13.8333 6.40896 13.8333 7.42809Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileMenuCabinet);
export default ForwardRef;